export const IllustError = ({ width = '100%' }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} viewBox='0 0 375 140' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_2932_30877)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M198.603 41.4817H174.262L176.933 31.3122C179.784 20.4623 193.081 20.4623 195.932 31.3122L198.603 41.4817Z'
        fill='url(#paint0_linear_2932_30877)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M206.854 72.8784H166.012L170.136 57.1787H202.73L206.854 72.8784Z'
        fill='url(#paint1_linear_2932_30877)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M215.043 104.048H157.82L161.887 88.5781H210.977L215.043 104.048Z'
        fill='url(#paint2_linear_2932_30877)'
      />
      <path
        d='M215.901 103.774H157.563C152.052 103.774 147.584 108.242 147.584 113.753H225.88C225.88 108.242 221.412 103.774 215.901 103.774Z'
        fill='url(#paint3_linear_2932_30877)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M170.135 57.1789H202.729L198.603 41.4819H174.261L170.135 57.1789Z'
        fill='url(#paint4_linear_2932_30877)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M161.887 88.5781H210.976L206.853 72.8784H166.011L161.887 88.5781Z'
        fill='url(#paint5_linear_2932_30877)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_2932_30877'
        x1='198.247'
        y1='41.4817'
        x2='186.432'
        y2='41.4817'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AAAAAA' />
        <stop offset='1' stopColor='#CCCCCC' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2932_30877'
        x1='206.691'
        y1='72.8784'
        x2='177.906'
        y2='72.8784'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#AAAAAA' />
        <stop offset='1' stopColor='#CCCCCC' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2932_30877'
        x1='162.552'
        y1='104.048'
        x2='209.76'
        y2='104.048'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#CCCCCC' />
        <stop offset='1' stopColor='#AAAAAA' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2932_30877'
        x1='186.732'
        y1='103.774'
        x2='186.732'
        y2='113.753'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#CCCCCC' />
        <stop offset='1' stopColor='#AAAAAA' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_2932_30877'
        x1='202.852'
        y1='57.1789'
        x2='186.732'
        y2='57.1789'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E7E7E7' />
        <stop offset='1' stopColor='#F9F9F9' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_2932_30877'
        x1='211.295'
        y1='88.5781'
        x2='194.408'
        y2='88.5781'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E7E7E7' />
        <stop offset='1' stopColor='#F9F9F9' />
      </linearGradient>
      <clipPath id='clip0_2932_30877'>
        <rect width='109' height='93.648' fill='white' transform='translate(133 23.1758)' />
      </clipPath>
    </defs>
  </svg>
);
